import {Component, OnDestroy, OnInit, signal} from "@angular/core";
import {UserInfoService} from "../../user-info.service";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

const MS_AUTH_CODE_KEY = 'code';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    standalone: false
})
export class LoginPageComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  returnUrl: string = '';
  public isHandlingRedirect = signal(false);

  constructor(private userInfo: UserInfoService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    // The app was configured to use the login page as the post auth redirect page
    // (which is not a typical setup, usually the redirect page is separate).
    // Check for the presence of a code in the hash params in order to determine
    // if this component should handle processing an authorization code received from Microsoft
    // see: https://learn.microsoft.com/en-us/entra/identity-platform/v2-oauth2-auth-code-flow#successful-response-1
    const hashParams = new URLSearchParams(this.route.snapshot.fragment ?? '');
    const shouldProcessMsCode = hashParams.has(MS_AUTH_CODE_KEY);
    if (shouldProcessMsCode) {
      this.isHandlingRedirect.set(true);
      broadcastResponseToMainFrame().catch((e) => {
        console.error('frame broadcast error', e);
      });
    } else {
      this.subscriptions.push(this.route.queryParams.subscribe(params => this.returnUrl = params.return || ''));
      this.subscriptions.push(this.userInfo.loginStateChanged.subscribe(loggedIn => {
        if (loggedIn) {
          this.router.navigateByUrl(this.returnUrl);
        }
      }));
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
